import React, { useEffect, useState, useRef } from 'react';
import clientLogo from '../../assets/images/logo/logo-khaihoanprime.png';
import clientText from './JASARI_Slogan.webp';
import { createPortal } from 'react-dom';

import './style.scss';
// import patternPng from './khp-pattern-sm.png';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const LoadingImage = (props) => {
  const { loaded, onClosing, onClosed } = props;
  const [enabled, setEnabled] = useState(true);
  const [enableAnimation, setEnabledAnimation] = useState(false);
  const startTimer = useRef(Date.now());
  const loadingRef = useRef(null);

  useEffect(() => {
    if (loaded) {
      (async () => {
        const elapsedTime = Date.now() - startTimer.current;

        if (elapsedTime < 2000) {
          await delay(2000);
        }
        setEnabledAnimation(true);
        await delay(2000);
        onClosing && onClosing();
        setEnabled(false);

        document.body.classList.add('app-ready');

        onClosed && onClosed();
      })();
    }
    // eslint-disable-next-line
  }, [loaded]);

  const progress = useRef(0);
  const progressEl = useRef(null);

  useEffect(() => {
    const updateProgress = () => {
      const el = progressEl.current;
      if (el) {
        el.style.width = `${progress.current}%`;
      }
    };
    if (loaded) {
      setTimeout(() => {
        progress.current = 100;
        updateProgress();
      }, 1000);
      return;
    }
    const timer = setInterval(() => {
      progress.current += 1;
      updateProgress();
      if (progress.current >= 100) {
        clearInterval(timer);
      }
    }, 40);

    return () => clearInterval(timer);
  }, [progress, loaded]);

  useEffect(() => {
    if (loadingRef.current) {
      const timer = setTimeout(() => {
        document.body.classList.add('loading-ready');
      }, 50);

      return () => {
        clearTimeout(timer);
        document.body.classList.remove('loading-ready');
      };
    }
  }, []);

  return (
    <>
      {enabled
        ? createPortal(
            <div
              ref={loadingRef}
              className={`loading-container ${
                enableAnimation ? 'fade-out' : ''
              }`}
            >
              <div className="loading-image">
                <img src={clientLogo} alt="Loading intro" />
                <img
                  className="loading-text"
                  src={clientText}
                  alt="Loading intro text"
                  style={{ width: '100%' }}
                />

                <div className="loading-bar">
                  <p ref={progressEl} className="loading-progress">
                    &nbsp;
                  </p>
                </div>
              </div>
            </div>,
            document.body
          )
        : null}
    </>
  );
};

export default LoadingImage;
